
import { markdownToHtml } from '~/utils/helpers'

export default {
  name: 'ChapterInfo',
  props: {
    tabInfo: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      isShowQuarterDescription: true,
      i18n: 'pages.education.courses-list.quarter'
    }
  },

  computed: {
    descriptionToggleText() {
      const text = this.isShowQuarterDescription ? 'hide' : 'show'

      return this.$t(`${this.i18n}.${text}`)
    },

    marked() {
      return markdownToHtml(this.tabInfo.description)
    }
  },

  methods: {
    toggleTabDescription() {
      this.isShowQuarterDescription = !this.isShowQuarterDescription
    }
  }
}
